import { ReactComponent as ArrowDownIcon } from 'app/assets/img/arrow-down-icon.svg';
import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import StyledSelect from '../../NewAccount/components/StyledSelect';
import { ALL_MONTHS, IReportPeriod } from '../constants';
import { REPORT_MOBILE_WIDTH } from './reportChartUtils';

export type { IReportPeriod };
export { ALL_MONTHS };

export interface IUseReportPeriod {
  period: IReportPeriod;
  onChangePeriod: (period: Partial<IReportPeriod>) => void;
}

export interface IUseReportPeriodOptions {
  onChange?: (period: IReportPeriod) => void;
}

export const useReportPeriod = (
  options?: IUseReportPeriodOptions,
): IUseReportPeriod => {
  const { onChange } = options ?? {};
  const [period, setPeriod] = useState<IReportPeriod>({
    month: ALL_MONTHS,
    year: new Date().getFullYear(),
  });

  const onChangePeriod = (value: Partial<IReportPeriod>) => {
    const next = { ...period, ...value };
    setPeriod(next);
    onChange?.(next);
  };

  return { period, onChangePeriod };
};

export const getRecentYearOptions = () => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 3 }, (_, i) => ({
    label: String(currentYear - i),
    value: currentYear - i,
  }));
};

interface IReportPeriodFilterProps {
  translations: any;
  period: IReportPeriod;
  onChange: (period: Partial<IReportPeriod>) => void;
}

export function ReportPeriodFilter(props: IReportPeriodFilterProps) {
  const { translations, period, onChange } = props;

  const monthOptions = useMemo(
    () => [
      {
        label: translations?.['b2b.txt.fullYear'] ?? '',
        value: ALL_MONTHS,
      },
      {
        label: translations?.['b2b.txt.selectMonth'] ?? '',
        options: Array.from({ length: 12 }, (_, i) => ({
          label: `${translations?.['b2b.txt.month'] ?? ''} ${i + 1}`,
          value: i + 1,
        })),
      },
    ],
    [translations],
  );

  const yearOptions = useMemo(() => getRecentYearOptions(), []);

  return (
    <FilterWrapper>
      <StyledSelect
        className="filter-month"
        suffixIcon={<ArrowDownIcon />}
        height="36px !important"
        value={period.month}
        onChange={value => onChange({ month: Number(value) })}
        options={monthOptions}
      />
      <StyledSelect
        className="filter-year"
        suffixIcon={<ArrowDownIcon />}
        height="36px !important"
        value={period.year}
        onChange={value => onChange({ year: Number(value) })}
        options={yearOptions}
      />
    </FilterWrapper>
  );
}

const FilterWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  .filter-month {
    min-width: 120px;
  }
  .filter-year {
    min-width: 110px;
  }
  @media (max-width: ${REPORT_MOBILE_WIDTH}px) {
    width: 100%;
    .filter-month,
    .filter-year {
      flex: 1 1 0;
      min-width: 0;
    }
  }
`;

export default ReportPeriodFilter;
